"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDateToInvoicingDateRange = transformDateToInvoicingDateRange;
const utils_1 = require("@daytrip/utils");
const date_fns_1 = require("date-fns");
/**
 * Transforms a date to a date range for invoicing purposes. The date range represents the start to end of the previous month from the given date.
 * @param date The current date.
 * @returns The date range for invoicing purposes.
 */
function transformDateToInvoicingDateRange(date) {
    const lastMonthDate = (0, date_fns_1.subMonths)(date, 1);
    const startAt = (0, date_fns_1.startOfMonth)(lastMonthDate);
    const endAt = (0, date_fns_1.endOfMonth)(lastMonthDate);
    return {
        startAt: (0, utils_1.zonedTimeToUtcOrDefault)(startAt, "UTC"),
        endAt: (0, utils_1.zonedTimeToUtcOrDefault)(endAt, "UTC"),
    };
}
//# sourceMappingURL=transformDateToInvoicingDateRange.js.map